const firebase = window.firebase;

const development = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';

export function logEvent(eventName, eventParams) {
    if (!development) {
        firebase.analytics().logEvent(eventName, eventParams);   
    }
}